export enum CustomPushNotificationLevelEnum {
    RESELLER = 'RESELLER',
    CLIENT = 'CLIENT',
}
